<template>
    <div>
        <el-form :model="from" :rules="rules" ref="ruleForm" label-width="170px">
            <table style="width: 95%; margin: 0 2%; margin-top: 20px;">
                <tr>
                    <td style="height: 30px; width: 25%;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">社保编号：</span>
                            </template>
                            <el-input placeholder="请输入社保编号" v-model="from.social_security_no" size="small"
                                style="width: 100%;"></el-input>
                        </el-form-item>
                    </td>
                    <td style="width: 25%;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">医保编号：</span>
                            </template>
                            <el-input placeholder="请输入医保编号" v-model="from.medical_insurance_no" size="small"
                                style="width: 100%;"></el-input>
                        </el-form-item>
                    </td>
                    <td style="width: 25%;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">保险类别：</span>
                            </template>
                            <el-select v-model="from.insurance_type_id" placeholder="请选择保险类别" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in insuranceTypeList" :key="item.id" :label="item.data"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td style="width: 25%;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">五险参保开始月份：</span>
                            </template>
                            <el-date-picker v-model="from.insured_begin_date" type="month" placeholder="请选择五险参保开始月份"
                                style="width: 100%;" value-format="yyyy-MM" size="small">
                            </el-date-picker>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td style="height: 30px;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">缴纳社保城市：</span>
                            </template>
                            <el-select v-model="from.insured_city" placeholder="请选择缴纳社保城市" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city"
                                    :value="item.city">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">缴纳类别：</span>
                            </template>
                            <el-select v-model="from.payment_type" placeholder="请选择缴纳类别" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city"
                                    :value="item.city">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">雇主出险记录：</span>
                            </template>
                            <el-button plain size="mini">出险记录</el-button>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">雇主出险状态：</span>
                            </template>
                            <el-input v-model="from.entry_type" size="small" disabled style="width: 100%;"></el-input>
                        </el-form-item>
                    </td>
                </tr>

                <tr>
                    <td style="height: 30px;">
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">是否缴纳公积金：</span>
                            </template>
                            <el-radio v-model="from.is_accumulation_fund" label="1">是</el-radio>
                            <el-radio v-model="from.is_accumulation_fund" label="0">否</el-radio>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">公积金编号：</span>
                            </template>
                            <el-input placeholder="请输入公积金编号" v-model="from.accumulation_fund_no" size="small"
                                style="width: 100%;">
                            </el-input>
                        </el-form-item>
                    </td>
                    <td>
                        <el-form-item style="margin-bottom: 0;">
                            <template slot="label">
                                <span
                                    style="text-align: right; color: #a1a1a1; line-height: 48px; font-size: 16px;">缴纳月是否扣医保大额：</span>
                            </template>
                            <el-select v-model="from.is_insurance_medical" placeholder="请选择缴纳月是否扣医保大额" size="small" clearable
                                style="width: 100%;">
                                <el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city"
                                    :value="item.city">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td></td>
                </tr>
            </table>
        </el-form>
    </div>
</template>

<script>
    export default {
        props: ["from"],
        data() {
            return {
                //保险类别
                insuranceTypeList: [],

                medicalLevel:[{
					value: '否',
					label: '否'
				}, {
					value: '按剩余月扣费',
					label: '按剩余月扣费'
				}, {
					value: '按年扣费',
					label: '按年扣费'
				}],


            }
        },
        async created() {
            //初始化保险类别
            var insuranceTypeList = await this.$globals.AxiosPost("dictionaries/selectFind", {
                data_grouping: "insurance_type"
            });
            this.insuranceTypeList = insuranceTypeList.data;
        }
    }
</script>

<style scoped="scoped">
    >>>.el-button {
        border: 1px solid #006e48;
        color: #006e48;
    }

    >>>.el-button:hover {
        border: 1px solid #006e48;
        color: #006e48;
    }

    >>>.el-radio__input.is-checked .el-radio__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-radio__input.is-checked+.el-radio__label {
        color: #006E4B;
    }
</style>



// WEBPACK FOOTER //
// insurance.vue?02a7c7a0